<template>
	<div class="white-block">
		<div class="patient-info-title">
			<div class="sched_plus" v-if="isCanWrite"></div>
			<i class="edit"></i>
			<p>Диспансерное наблюдение</p>
		</div>
		<div class="patient-form">
			<div class="patient-form-block" v-for="record in diseaseAccounting">
				<label for="label-1">{{record.label}}:</label>
				<input id="label-1" type="text" v-model="record.value" readonly="readonly"/>
			</div>
			<div class="patient-form-block" v-if="!diseaseAccounting.length">
				Нет записей
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: "DiseaseAccounting",
		computed: {
			userId() {
				return this.$route.query.patient
			},
			workerId() {
				return this.$route.query.doctor
			},
			isCanWrite() {
				return this.$parent.isCanWrite
			}
		},
		mounted(){
			this.$store.dispatch('card/getByType', {
				type: "disease_accounting",
				worker_id: this.workerId,
				user_id: this.userId
			}).then(response => {
				this.diseaseAccounting = response
			})
		},
		data() {
			return {
				diseaseAccounting: []
			}
		}
	}
</script>
<style>
	.sched_plus {
		float: right;
	}
</style>



// WEBPACK FOOTER //
// DiseaseAccounting.vue?5470795a